import { Compiler, Injectable } from '@angular/core';
import { Observable, Subject, AsyncSubject, from, forkJoin } from 'rxjs';
import { Router } from "@angular/router";
import { I18nService } from '../services/i18n/i18n.service'
import { ApiRequestService } from '../http/api-request.service'
import { LookupDataService } from '../http/lookupdata.service'
import { CommonUtilty } from '../utilities/commonUtility'
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import { environment } from 'environments/environment'
import { zip } from 'rxjs/operators';
import { InterApplicationCommunicationService } from '../services/inter-application-communication/inter-app-communication.service';
import { MultiLingualService } from '../services/multi-lingual/multi-lingual.service';
import config from '../../../../configs/health-nbu-transaction.json'

@Injectable({
  providedIn: 'root'
})
export class ThreadsService {

  constructor(private router: Router,
    private i18nService: I18nService,
    public appMetadataHandler: AppMetadataHandler,
    private commonUtilty: CommonUtilty,
    private apiRequestService: ApiRequestService,
    private lookUpDataService: LookupDataService,
    private interAppCommunicationService: InterApplicationCommunicationService,
    private multiLingualService: MultiLingualService,
    private compiler: Compiler) { }

  APPLICATIONBOOTSTRAPTHREAD() {
    let msg = 'Application Bootstrap Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    if (!environment['disableCacheClear']) {
      this.compiler.clearCache()
    }
    this.router.navigateByUrl(environment['landingRoute']);
    this.i18nService.init(this.appMetadataHandler.defaultLanguage, this.appMetadataHandler.supportedLanguages);
    this.appMetadataHandler.initializeConfig()
    this.commonUtilty.preventBackButton();
    this.apiRequestService.resetSessionExpiredMsgID()
    caller.next({ status: true });
    caller.complete();
    return caller;
  }

  PRELOGINTHREAD() {
    let msg = 'Pre-Login Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    this.apiRequestService.resetSessionExpiredMsgID()
    caller.next({ status: true });
    caller.complete();
    return caller;
  }

  POSTLOGINTHREAD() {
    let msg = 'Post-Login Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    let threadList: Array<any> = []
    // threadList.push(this.APIENDPOINTMAPPERSTRATEGY())
    threadList.push(this.LOOKUPPRELOADSTRATEGY())
    threadList.push(this.FETCHCONFIGJSON())
    threadList.push(this.SETDEFAULTLANGUAGE())
    //threadList.push(this.FETCHCUSTOMCOMPONENTSLIST());
    forkJoin(threadList).subscribe(res => {
      caller.next({ status: res });
      caller.complete();
    })

    return caller;
  }

  SETDEFAULTLANGUAGE(){
    let msg = 'SET DEFAULT LANGUAGE Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    // this.apiRequestService.get(environment['configPath'], null, true).subscribe(res => {
    //   if (res) {
    
        this.multiLingualService.setDefaultLanguage(this.appMetadataHandler.defaultLanguage);
        this.multiLingualService.setLanguage(this.appMetadataHandler.defaultLanguage);
        this._successThreadLog('FETCH CONFIG Thread Completed');
        caller.next({ status: true });
        caller.complete();
    //   }
    //   else {
    //     this._errorThreadLog('There is some problem in FETCH CONFIG Thread. Invalid Response from Server. Cannot move ahead without this');
    //   }
    // })
    return caller;
  }

  APIENDPOINTMAPPERSTRATEGY() {
    let msg = 'API MASTER LOAD Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    this.apiRequestService.getAPIMaster().subscribe(res => {
      if (res) {
        this._successThreadLog('API MASTER LOAD Thread Completed');
        caller.next({ status: true });
        caller.complete();
      }
      else {
        this._errorThreadLog('There is some problem in API MASTER LOAD Thread. Invalid Response from Server. Cannot move ahead without this');
      }
    })
    return caller;
  }

  FETCHCONFIGJSON() {
    let msg = 'FETCH CONFIG Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    // this.apiRequestService.get(environment['configPath'], null, true).subscribe(res => {
    //   if (res) {
        // this.appMetadataHandler.configDataJSON = this.commonUtilty.deepCopy(res);
        this.appMetadataHandler.configDataJSON = config;
        this._successThreadLog('FETCH CONFIG Thread Completed');
        caller.next({ status: true });
        caller.complete();
    //   }
    //   else {
    //     this._errorThreadLog('There is some problem in FETCH CONFIG Thread. Invalid Response from Server. Cannot move ahead without this');
    //   }
    // })
    return caller;
  }

  LOOKUPPRELOADSTRATEGY() {
    let msg = 'Lookup Preload Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    let lookupList = [...this.appMetadataHandler.preloadLookups[this.appMetadataHandler.entryViewModule]];
    //send list of LookupCd and fetch list of LookupCds
    this.lookUpDataService.getLookupList(lookupList).subscribe(res => {
      if (res)
        this._successThreadLog('Lookup Preload Thread Completed');
      else
        this._errorThreadLog('There is some problem in Lookup Preload Thread');
      caller.next({ status: true });
      caller.complete();
    })
    return caller;
  }

  /*FETCHCUSTOMCOMPONENTSLIST() {
    let msg = 'FETCH ALL CUSTOM COMPONENTS Thread Started. . .'
    this._startThreadLog(msg)
    let caller: AsyncSubject<any> = new AsyncSubject<any>();
    this.lookUpDataService.getLookup('CustomComponents').subscribe(res => {
      if (res) {
        this.lookUpDataService.customComponentsList = this.commonUtilty.deepCopy(res);
        console.log("custom components list", this.lookUpDataService.customComponentsList)
        this._successThreadLog('FETCH ALL Custom Components List Thread Completed');
        caller.next({ status: true });
        caller.complete();
      }
      else {
        this._errorThreadLog('There is some problem in FETCH Custom Components Thread. Invalid Response from Server. Cannot move ahead without this');
      }
    })
    return caller;
  }*/

  _startThreadLog(msg) {
    console.log(`${msg}`, 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
  }

  _successThreadLog(msg) {
    console.log(`${msg}`, 'color: white; background-color: green; padding: 2px 5px; border-radius: 2px');
  }

  _errorThreadLog(msg) {
    console.log(`${msg}`, 'color: white; background-color: red; padding: 2px 5px; border-radius: 2px');
  }
}
